import {createStore, withProps} from '@ngneat/elf';
import {withEntities, withUIEntities} from '@ngneat/elf-entities';
import {withRequestsStatus} from '@ngneat/elf-requests';
import {withPagination} from '@ngneat/elf-pagination';
import {GridSortItem} from '@mui/x-data-grid-pro';

import {Supplier, SuppliersFilters, SupplierUI} from '@store/suppliers/suppliers.model';
import {GlobalStatus} from '@store/common/globalStatus.enum';
import {TablePagination} from '@store/common/pagination.model';
import {TableConfig} from '@constants/table.constants';

export interface SuppliersState {
  status?: GlobalStatus;
  filters: SuppliersFilters;
  sort: GridSortItem;
  tablePagination: TablePagination;
}

export const suppliersStore = createStore(
  {name: 'suppliers'},
  withProps<SuppliersState>({
    status: undefined,
    filters: {search: '', tableFilters: SuppliersFilters.initTableFilters()},
    sort: {
      field: 'organisation.name',
      sort: 'asc',
    },
    tablePagination: {
      page: 1,
      limit: TableConfig.pagination,
    },
  }),
  withEntities<Supplier>(),
  withUIEntities<SupplierUI>(),
  withPagination(),
  withRequestsStatus(),
);